import { useTranslation } from "react-i18next";

import { Skeleton } from "../../../../components/Skeleton";
import { Card } from "../../styles";
import { CardShape, FormShape, WalletsShape } from "./styles";

/** The card while it loads: its shape (logo, photo, name, what the person does, QR, address), pulsing. */
export const CardSkeleton = () => {
  const { t } = useTranslation();

  return (
    <CardShape role="figure" aria-label={t("pages.businessCard.loadingCard")} aria-busy="true">
      <Skeleton className="logo" />
      <Skeleton className="photo" />
      <Skeleton className="name" />
      <Skeleton className="role" />
      <Skeleton className="qr" />
      <Skeleton className="url" />
    </CardShape>
  );
};

/** The form while the card loads: its title, its fields (the Keepo, the name beside what the person does), saving. */
export const FormSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <FormShape role="group" aria-label={t("pages.businessCard.loadingForm")} aria-busy="true">
        <div className="head">
          <Skeleton className="title" />
          <Skeleton className="line" />
        </div>
        <div className="field">
          <Skeleton className="label" />
          <Skeleton className="input" />
        </div>
        <div className="two">
          {[0, 1].map(field => (
            <div className="field" key={field}>
              <Skeleton className="label" />
              <Skeleton className="input" />
            </div>
          ))}
        </div>
        <Skeleton className="button" />
      </FormShape>
    </Card>
  );
};

/** The wallets' buttons under the card, while it loads. */
export const WalletsSkeleton = () => (
  <WalletsShape aria-hidden="true">
    <Skeleton className="wallet" />
    <Skeleton className="wallet" />
  </WalletsShape>
);
